import React from 'react';

interface FormControlLabelProps {
  control: React.ReactElement;
  label?: string;
  labelPlacement?: 'end' | 'start' | 'top' | 'bottom';
  className?: string;
}

const FormControlLabel: React.FC<FormControlLabelProps> = ({
  control,
  label,
  labelPlacement = 'end',
  className = '',
}) => {
  const placementClasses = {
    end: 'flex-row',
    start: 'flex-row-reverse',
    top: 'flex-col',
    bottom: 'flex-col-reverse',
  };

  return (
    <label className={`flex items-center ${placementClasses[labelPlacement]} ${className}`}>
      {control}
      {label && <span className="ml-2 text-sm text-gray-700 dark:text-gray-300">{label}</span>}
    </label>
  );
};

export default FormControlLabel;

